import { useContext } from 'react';
import { Col, Row, Table, Tag } from 'antd';
import {
    IdcardOutlined,
    MobileOutlined,
    ShopOutlined,
    TeamOutlined,
    UserOutlined,
} from '@ant-design/icons';

import useAppUsersAuto from './useAppUsersAuto';
import PageHeader from '../../components/PageHeader';
import ActiveFiltersBar from '../../components/ActiveFiltersBar';
import TableCard from '../../components/TableCard';
import TableDicaHint from '../../components/TableDicaHint';
import TablePagination from '../../components/TablePagination';
import KpiCard from '../../components/KpiCard';
import { ThemeContext } from '../../contexts/ThemeContext';
import { poeValorComPontosEmMil } from '../../utils/Conversores';

export default function AppUsersAuto() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    const {
        isLoading,
        columns,
        tableData,
        totalAppUsers,
        pagination,
        activeFilterItems,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        navigate,
    } = useAppUsersAuto();

    const totalCount = (totalAppUsers?.total_cpf || 0) + (totalAppUsers?.total_cnpj || 0);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <PageHeader
                icon={<IdcardOutlined />}
                title="Usuários (IPTU)"
                tag={<Tag color="blue">{poeValorComPontosEmMil(totalCount || tableData.length)} cadastrados</Tag>}
                subtitle="Gerencie e visualize todos os contribuintes e usuários importados do sistema de IPTU"
            />

            {totalAppUsers && (
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={6}>
                        <KpiCard
                            icon={<TeamOutlined />}
                            title="Total de Usuários"
                            value={poeValorComPontosEmMil((totalAppUsers?.total_cpf || 0) + (totalAppUsers?.total_cnpj || 0))}
                            accentColor="#1677ff"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <KpiCard
                            icon={<UserOutlined />}
                            title="Pessoas Físicas (CPF)"
                            value={poeValorComPontosEmMil(totalAppUsers?.total_cpf || 0)}
                            accentColor="#52c41a"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <KpiCard
                            icon={<ShopOutlined />}
                            title="Pessoas Jurídicas (CNPJ)"
                            value={poeValorComPontosEmMil(totalAppUsers?.total_cnpj || 0)}
                            accentColor="#722ed1"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <KpiCard
                            icon={<MobileOutlined />}
                            title="Com Cadastro no App"
                            value={poeValorComPontosEmMil(totalAppUsers?.total_cpf_com_cadastro_app || 0)}
                            accentColor="#fa8c16"
                        />
                    </Col>
                </Row>
            )}

            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Dê um clique na linha ou utilize o botão de ação para ver os detalhes do usuário." />

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={tableData.length}
                itemName="usuários (IPTU)"
                pageSizeOptions={['10', '25', '50', '100', '200']}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="id"
                    className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        position: [],
                    }}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                        onClick: () => {
                            navigate(`/usuarios/auto/${record.id}`);
                        },
                        style: {
                            cursor: 'pointer',
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={tableData.length}
                itemName="usuários (IPTU)"
                pageSizeOptions={['10', '25', '50', '100', '200']}
                onChange={handlePaginationChange}
            />
        </div>
    );
}
